






























import Vue from "vue";

export default Vue.extend({
  name: "pagination",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      curPage: 1,
    };
  },
  computed: {
    pageCount() {
      const total = this.total;
      const limit = this.limit;
      if (total % limit !== 0) {
        return parseInt(`${total / limit}`, 10) + 1;
      }
      return parseInt(`${total / limit}`, 10);
    },
    pageArray() {
      // TODO: 这规则绝了，待优化
      const curPage = this.curPage;
      const pageCount = this.pageCount;
      if (pageCount <= 4) {
        return [...new Array(pageCount).keys()].map((v) => v + 1);
      }

      if (pageCount === 5) {
        if (curPage === 1) {
          return [1, 2, 3, "...", pageCount];
        } else if (curPage === 5) {
          return [1, "...", 3, 4, pageCount];
        } else {
          return [1, 2, 3, 4, 5];
        }
      }

      const rawArray = [...new Array(pageCount).keys()].map((v) => v + 1);
      if (curPage === 1) {
        return [1, 2, 3, "...", pageCount];
      }

      if (curPage === 2) {
        return [1, 2, 3, 4, "...", pageCount];
      }

      if (pageCount - curPage <= 1 && pageCount - curPage >= 0) {
        return [1, "...", pageCount - 2, pageCount - 1, pageCount];
      }

      if (curPage - 2 > 1 && curPage + 3 < pageCount) {
        return [
          1,
          "...",
          curPage - 2,
          curPage - 1,
          curPage,
          curPage + 1,
          curPage + 2,
          "...",
          pageCount,
        ];
      } else {
        if (curPage - 2 <= 1) {
          return [1, 2, 3, 4, "...", pageCount];
        }

        if (curPage + 3 >= pageCount) {
          return [
            1,
            "...",
            pageCount - 3,
            pageCount - 2,
            pageCount - 1,
            pageCount,
          ];
        }
      }

      return rawArray;
    },
  },
  watch: {
    curPage(newPage, oldPage) {
      if (newPage !== oldPage) {
        this.$emit("change", newPage, this.limit);
      }
    },
    pageCount(newCount) {
      if (newCount === this.curPage - 1) {
        this.curPage = newCount;
      }
    },
  },
  methods: {
    onPageChange(cur: number | string) {
      if (cur === "...") {
        return;
      }
      this.curPage = cur;
    },
    onPageUp() {
      if (this.curPage === 1) {
        return;
      }
      this.curPage = this.curPage - 1;
    },
    onPageDown() {
      if (this.curPage === this.pageCount) {
        return;
      }
      this.curPage = this.curPage + 1;
    },
  },
});
